import SharedPreferences from "../../constants/SharedPreferences";
import {
  getErrorMessage,
  saveInStorage,
  getFromStorage,
  logApiResponse,
} from "../../util/Utility";
import { getAuthRestclient } from "../RestUtility";
/**
 * Calls the API to save the stats on LMS.
 *
 * @param {String} sessionId id of the session in question.
 * @param {int} decryptionCount times decryption was performed since last time stats were updated.
 * @param {int} encryptionCount times encryption was performed since last time stats were updated.
 * @param {String} lastOperationTime the time when last time any operation was performed
 * @param {String} lmsStatisticsKey the key used by LMS to temporarily decrypt data and add the stats.
 */
export const saveStatististicsAPI = async (
  sessionId,
  decryptionCount,
  encryptionCount,
  lastOperationTime,
  lmsStatisticsKey,
) => {
  // create rest client
  const restClient = await getAuthRestclient(sessionId);

  try {
    const saveMemberStatisticsResponse = await restClient.post(
      "/memberStatistics",
      {
        decryptionCount,
        encryptionCount,
        lastOperationTime,
        lmsStatisticsKey,
      },
    );

    // console.log(saveMemberStatisticsResponse);
    await logApiResponse(
      "saveMemberStatisticsResponse",
      saveMemberStatisticsResponse,
    );
    const statsSyncTime = await getFromStorage(
      sessionId,
      SharedPreferences.STATS_SYNC_TIME_DURATION,
    );
    const currentTime = new Date().valueOf();
    const statsExpiryTime = currentTime + statsSyncTime * 60 * 1000;
    await saveInStorage(
      sessionId,
      SharedPreferences.STATS_SYNC_EXPIRY_TIME,
      statsExpiryTime,
    );
  } catch (error) {
    console.log(error);
    console.log(error?.response?.data ?? error);
    throw getErrorMessage(sessionId, error?.response?.data ?? error);
  }
};

/**
 * Calls the API to save the stats on LMS.
 *
 * @param {String} sessionId id of the session in question.
 * @param {String} decryptionCount times decryption was performed since last time stats were updated.
 * @param {String} encryptionCount times encryption was performed since last time stats were updated.
 * @param {String} adminEncryptedStatisticsKey
 * @param {String} adminEncryptedStatisticsKeyKek
 * @param {String} lmsEncryptedStatisticsKey
 * @param {String} memberAppId
 */
export const saveMemberAppStatisticsKeysAPI = async (
  sessionId,
  decryptionCount,
  encryptionCount,
  adminEncryptedStatisticsKey,
  adminEncryptedStatisticsKeyKek,
  lmsEncryptedStatisticsKey,
  memberAppId,
) => {
  // create rest client
  const restClient = await getAuthRestclient(sessionId);

  try {
    const saveMemberStatisticsResponse = await restClient.post(
      "/saveMemberAppStatisticsKeys",
      {
        decryptionCount,
        encryptionCount,
        adminEncryptedStatisticsKey,
        adminEncryptedStatisticsKeyKek,
        lmsEncryptedStatisticsKey,
        memberAppId,
      },
    );

    // console.log(
    //   "saveMemberStatisticsResponse",
    //   saveMemberStatisticsResponse
    // );
    await logApiResponse(
      "saveMemberStatisticsResponse",
      saveMemberStatisticsResponse,
    );
  } catch (error) {
    console.log(error);
    console.log(error?.response?.data ?? error);
    throw getErrorMessage(sessionId, error?.response?.data ?? error);
  }
};
